<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="add-article-dialog"
  >
    <article-form
      ref="outform"
      @submit="submit"
    ></article-form>
  </sliderBarDialogShell>
</template>

<script>
import articleForm from "@/components/wx/article/articleForm";

import {saveArticle} from "../../../api/wx/acticle";

export default {
  name: "articleDialog",
  components: {
    articleForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      title: '新增公众号文章'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form) {

      saveArticle(form).then((data) => {

        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '添加成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        }else{
          this.$message.error(data.msg);
        }
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .add-article-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>

